import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/notFound',
    hidden: true
  },
  {
    path: '/notFound',
    name: 'notFound',
    component: () => import('@/views/notFound/index.vue')
  },
  {
    path: '/:uuid',
    name: 'home',
    component: () => import('@/views/home/index.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router